import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const dateFormatter = new Intl.DateTimeFormat('nl-NL', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

const timeFormatter = new Intl.DateTimeFormat('nl-NL', {
  hour: '2-digit',
  minute: '2-digit',
});

export type TimelineCardProps = {
  timestamp: Date | string;
  heading: string;
  subtext?: string;
  performedBy: string;
  className?: string;
};

const formatTimestamp = (timestamp: Date | string) => {
  const date =
    typeof timestamp === 'string' ? new Date(timestamp) : timestamp;

  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return {
      dateLabel: typeof timestamp === 'string' ? timestamp : '',
      timeLabel: '',
      dateTimeValue: undefined,
    };
  }

  return {
    dateLabel: dateFormatter.format(date),
    timeLabel: timeFormatter.format(date),
    dateTimeValue: date.toISOString(),
  };
};

const TimelineCard = ({
  timestamp,
  heading,
  subtext,
  performedBy,
  className,
}: TimelineCardProps) => {
  const { dateLabel, timeLabel, dateTimeValue } = formatTimestamp(timestamp);

  return (
    <Card className={cn(className, 'border-slate-200 rounded-lg shadow-none')}>
      <CardHeader className="px-6 pt-0">
        <time
          dateTime={dateTimeValue}
          className="text-sm text-slate-500"
        >
          {dateLabel}
          {timeLabel ? ` • ${timeLabel}` : ''}
        </time>
        <CardTitle className="text-base font-semibold text-foreground">
          {heading}
        </CardTitle>
        {subtext ? (
          <CardDescription className="text-sm text-slate-800">
            {subtext}
          </CardDescription>
        ) : null}
      </CardHeader>
      <CardContent className="px-6 pt-0">
        <p className="text-xs text-slate-500">
          Door <span className="text-black">{performedBy}</span>
        </p>
      </CardContent>
    </Card>
  );
};

export default TimelineCard;
